import { render, staticRenderFns } from "./ProcessInputEvents.vue?vue&type=template&id=66b2f052&scoped=true"
import script from "./ProcessInputEvents.vue?vue&type=script&lang=js"
export * from "./ProcessInputEvents.vue?vue&type=script&lang=js"
import style0 from "./ProcessInputEvents.vue?vue&type=style&index=0&id=66b2f052&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2f052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b2f052')) {
      api.createRecord('66b2f052', component.options)
    } else {
      api.reload('66b2f052', component.options)
    }
    module.hot.accept("./ProcessInputEvents.vue?vue&type=template&id=66b2f052&scoped=true", function () {
      api.rerender('66b2f052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/ProcessInputEvents.vue"
export default component.exports